import { render, staticRenderFns } from "./LineChartTend.vue?vue&type=template&id=72c7cbaf&scoped=true&"
import script from "./LineChartTend.vue?vue&type=script&lang=js&"
export * from "./LineChartTend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c7cbaf",
  null
  
)

export default component.exports